import React, {useEffect} from "react";
import {errorCodeState} from "../../states/states";
import CustomSweetAlert from "../helper/CustomSweetAlert";
import getErrorMessage from "../../config/ErrorMessage";
import {useRecoilState} from "recoil/dist";
import logService from "../../services/log.service";
import i18n from 'i18next';

const withErrorMessage = BaseComponent => (props) => {
    const [errorCode, setErrorCode] = useRecoilState(errorCodeState);

    useEffect(() => {
        clearErrorMessage();
    },[]);
    const clearErrorMessage = () => {
        setErrorCode("");
    };

    const handleError = (error, action="") => {
        logService.log("error", action !== "" ? action : "TestLayout", error.toString(), error.stack);
        setErrorCode("SOME_THING_IS_WRONG");
        if (error.response) {
            if (error.response.data.status === 401)
                setErrorCode("NOT_GRANTED");
            else if (error.response.data.status !== 500)
                setErrorCode(error.response.data.message)
        }
    };

    if (errorCode !== "")
        return <CustomSweetAlert showConfirm={true} onConfirm={() => { clearErrorMessage()}}
                                 confirmBtnText={i18n.t('confirm')}
                                 text={getErrorMessage(errorCode)}/>;
    else
        return  <BaseComponent {...props} handleError={handleError} clearErrorMessage={clearErrorMessage}/>
};

export default withErrorMessage;